import { createProfileView } from "./viewTracker"

export function ready(athleteId, source) {
    const track = new Track()
    let tracked = false

    document.addEventListener(track.events.move, async () => {
        if (!tracked) {
            createProfileView({ resource_id: athleteId, source: source })
            tracked = true
        }
    })
}
